export default {
    init() {

      $( ".jobs-list__text__content__intro__more__button").click(function() {
        $(this).closest(".jobs-list__text__content").addClass("open");
      });
      $( ".jobs-list__text__content__collapse").click(function() {
        $(this).closest(".jobs-list__text__content").removeClass("open");
      });
    },
    finalize() {

    }
};
